const url = 'arquivo-integracao';
class ArquivoIntegracaoService {
    async getArquivoById(idArquivo) {
        const response = await window.$http.get(`${url}/${idArquivo}`, { responseType: 'blob' });
        return response.data;
    }
}
export default new ArquivoIntegracaoService();
